import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  _id: string;
  lrn: string;
  eori: string;
}

export const useCheckImporterEori = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, eori }: HookProps): Promise<boolean> => {
      const result = await apiClient.declarationsCustoms.checkImporterEori.mutation({
        params: { lrn },
        body: { eori },
      });
      if (result.status !== 200) throw result.body;
      return result.body.isValid;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables._id] });
      toast.success('Declaration changes were saved!');
    },
    onError: (error) => {
      showErrorToast(error, `Error checking eori!`);
    },
  });
};
